import { render, staticRenderFns } from "./DepositRecord.vue?vue&type=template&id=3c39951e&scoped=true&"
import script from "./DepositRecord.vue?vue&type=script&lang=js&"
export * from "./DepositRecord.vue?vue&type=script&lang=js&"
import style0 from "./DepositRecord.vue?vue&type=style&index=0&id=3c39951e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c39951e",
  null
  
)

export default component.exports